export default "__VITE_ASSET__BIgIYp$m__"